import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import { Tab } from 'react-toolbox/lib/tabs/Tab';
import { DivWithPopover } from 'common/components/core/wrappers/Div';

import theme from './TabWithCard.scss';
import coreIds from 'common/tests/core/coreIds.json';

const applyTheme = Component => themr('TabWithCard', theme)(Component);

class TabWithCard extends Tab {
    render() {
        const {
            onActive, // eslint-disable-line
            active,
            activeClassName,
            className,
            disabled,
            hidden,
            icon,
            theme,
            leftIcon,
            rightIcon,
            subtitle,
            title,
            label,
            isPopOverOpen,
            popOverContent,
            popoverPlace,
            popoverClassName,
            'data-test-id': testId,
            ...others
        } = this.props;
        const _className = classnames(
            theme.label,
            {
                [theme.active]: active,
                [theme.hidden]: hidden,
                [theme.withText]: label,
                [theme.withIcon]: icon,
                [theme.disabled]: disabled,
                [activeClassName]: active
            },
            className
        );

        return (
            <label
                data-react-toolbox="tab"
                data-test-id={testId}
                className={_className}
                onClick={this.handleClick}
                {...others}
            >
                <div className={theme.tabLabel}>
                    {leftIcon !== undefined ? (
                        <div className={theme.leftIcon}>{leftIcon}</div>
                    ) : null}
                    <div className={theme.tabLabelContent}>
                        <span
                            data-test-id={coreIds.tab.title}
                            className={theme.title}
                        >
                            {title ? title : label}
                        </span>
                        {subtitle ? (
                            <span
                                data-test-id={coreIds.tab.subTitle}
                                className={theme.subtitle}
                            >
                                {subtitle}
                            </span>
                        ) : (
                            []
                        )}
                    </div>
                    {rightIcon !== undefined ? (
                        <div className={theme.rightIcon}>{rightIcon}</div>
                    ) : null}
                    {popOverContent && isPopOverOpen ? (
                        <DivWithPopover
                            isPopOverOpen={isPopOverOpen}
                            popOverContent={popOverContent}
                            preferPlace={popoverPlace}
                            className={popoverClassName}
                        />
                    ) : null}
                </div>
            </label>
        );
    }
}

const ThemedTabWithCard = applyTheme(TabWithCard);
export { ThemedTabWithCard as TabWithCard };
export default ThemedTabWithCard;
